import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useCsCfgObject } from "@plansoft-configuration-renderer/framework";
import { useUiTranslator } from "@plansoft-configuration-renderer/localization";
export function ConfigurationTypeCodeText() {
    const cfgObject = useCsCfgObject();
    const t = useUiTranslator();
    const labelText = t("ConfigurationRenderer:ConfigurationTypeCode.name", "Type code");
    const typeCode = cfgObject.typeCode;
    return (_jsxs(Box, { sx: {
            my: 2,
        }, children: [_jsx(Typography, { variant: "h6", color: "primary", children: labelText }), _jsx(Typography, { sx: {
                    whiteSpace: "pre-line",
                }, children: typeCode })] }));
}
//# sourceMappingURL=ConfigurationTypeCodeText.js.map